import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row justify-content-between mb-2" }
const _hoisted_4 = { class: "col-md-4 col-8 col-sm" }
const _hoisted_5 = { class: "row my-3" }
const _hoisted_6 = { class: "row approval-table-header-row" }
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 0,
  class: "row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_ClearableInput = _resolveComponent("ClearableInput")!
  const _component_InvoiceApprovalListCell = _resolveComponent("InvoiceApprovalListCell")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumbs, {
      here: '請求承認メッセージ一覧',
      ancestries: _ctx.ancestries
    }, null, 8, ["ancestries"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "col h2",
        style: _normalizeStyle({ fontSize: _ctx.FontSizes.large1})
      }, "請求承認メッセージ一覧", 4)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ClearableInput, {
          text: _ctx.searchText,
          "onUpdate:text": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event))
        }, null, 8, ["text"])
      ]),
      _withDirectives(_createElementVNode("select", {
        class: "month-select col-4 col-md-2 align-self-center",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.backwardMonthCountText) = $event))
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("option", { value: "0" }, "今月", -1),
        _createElementVNode("option", { value: "1" }, "前月", -1)
      ]))], 512), [
        [_vModelSelect, _ctx.backwardMonthCountText]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "col container",
        style: _normalizeStyle({fontSize: _ctx.FontSizes.small1})
      }, [
        _createElementVNode("div", _hoisted_6, [
          _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"col-1\" data-v-788b5f85><span class=\"wrap-text\" data-v-788b5f85>社員ID</span></div><div class=\"col-2\" data-v-788b5f85><span class=\"wrap-text\" data-v-788b5f85>社員名</span></div><div class=\"col-1\" data-v-788b5f85><span class=\"wrap-text\" data-v-788b5f85>支店名</span></div><div class=\"col-5\" data-v-788b5f85><span class=\"wrap-text\" data-v-788b5f85>メッセージ</span></div>", 4)),
          _withDirectives(_createElementVNode("select", {
            class: "col-3 mx-n1 text-center p-0",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedAcceptState) = $event))
          }, [
            _createElementVNode("option", {
              value: _ctx.acceptState.both
            }, "すべて表示", 8, _hoisted_7),
            _createElementVNode("option", {
              value: _ctx.acceptState.accept
            }, "承認済み", 8, _hoisted_8),
            _createElementVNode("option", {
              value: _ctx.acceptState.notAccept
            }, "未承認", 8, _hoisted_9)
          ], 512), [
            [_vModelSelect, _ctx.selectedAcceptState]
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchedApprovals, (apprv) => {
          return (_openBlock(), _createBlock(_component_InvoiceApprovalListCell, {
            key: apprv.vForKey,
            "invoice-approval": apprv
          }, null, 8, ["invoice-approval"]))
        }), 128)),
        (_ctx.searchedApprovals.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", {
                class: "col empty-table-text align-self-center my-5",
                style: _normalizeStyle({fontSize: _ctx.FontSizes.large1})
              }, "表示するデータは存在しません", 4)
            ]))
          : _createCommentVNode("", true)
      ], 4)
    ])
  ]))
}